module.exports = __webpack_public_path__ + "static/media/D39.bf2a08c0.svg";